/** Event listener for Google Analytics & Tag Manager */
const events = require('../core/events');
const EventTiming = require('../helpers/eventtiming');
const googleAnalytics = require('universal-ga');

const TIMING_INCREMENT = 30;

var listeningTimestamps = {};

// Track total listening time: Array of start + current times.
const musicTiming = new EventTiming();
var lastTotalMusic = 0;

function AnalyticsMonitor() {
  // TODO: Pull Google Analytics ID from mark-up?
  googleAnalytics.initialize('UA-53665120-1');
  this.addTagManager();

  document.addEventListener('click', this.handleAllClicks);

  document.addEventListener(events.navigationRequestEnded, this.handleNavigationRequestEnded);
  document.addEventListener(events.uiDidSearch, this.handleSearch);

  document.addEventListener(events.audioSourcePlaying, this.handleMusicStart);
  document.addEventListener(events.audioSourcePaused, this.handleMusicPause);
  document.addEventListener(events.audioSourceEnded, this.handleMusicComplete);
  document.addEventListener(events.audioSourceTimeUpdate, this.handleMusicProgress);

  // Log Initial Page Impression
  this.initialImpression();
}

AnalyticsMonitor.prototype.addTagManager = function addTagManager() {
  const insertAt = document.getElementsByTagName('script')[0];
  const tagScript = document.createElement('script');
  const initialEvent = {
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(initialEvent);

  tagScript.async = true;

  // TODO: Pull tag manager ID from mark-up
  tagScript.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-5B4BJ7V';
  insertAt.parentNode.insertBefore(tagScript, insertAt);
};

AnalyticsMonitor.prototype.initialImpression = function initialImpression() {
  const newPath = location.pathname;
  googleAnalytics.set('page', newPath);
  googleAnalytics.pageview();
};

AnalyticsMonitor.prototype.legacyBrowserImpression = function legacyBrowserImpression() {
  googleAnalytics.event('browser', 'legacyBrowserPageView');
};

AnalyticsMonitor.prototype.handleAllClicks = function handleAllClicks(e) {
  var payload = {};
  // HACK: Sentry is reporting a lot of errors with the `closest` function. Add guards.
  // TODO: Log info about the cases when `closest` doesn't exist.
  const linkTarget = (e.target && e.target.closest) && (e.target.closest('A') || e.target.closest('BUTTON'));

  if (!linkTarget) { return; }

  const action = linkTarget.getAttribute('data-analytics-clickaction') || linkTarget.tagName === 'A' ? 'link' : 'button';

  const label = linkTarget.getAttribute('data-analytics-label') || linkTarget.href;

  if (!label) { return; }

  payload = { eventLabel: label };
  const value = linkTarget.getAttribute('data-analytics-value') || undefined;

  if (!isNaN(value)) {
    payload.eventValue = value;
  }

  googleAnalytics.event('click', action, payload);
};

AnalyticsMonitor.prototype.handleNavigationRequestEnded = function onNavigationRequestEnded(e) {
  const newPath = location.pathname;
  googleAnalytics.set('page', newPath);

  if (e.detail && e.detail.didNavigate) {
    googleAnalytics.pageview(newPath);
  } else {
    googleAnalytics.event('error', 'navigation', {
      eventLabel: e.detail && e.detail.url
    });
  }
};

AnalyticsMonitor.prototype.handleSearch = function handleSearch(e) {
  googleAnalytics.event('search', 'search', {
    eventLabel: e.detail && e.detail.query
  });
};

AnalyticsMonitor.prototype.handleMusicStart = function onMusicStart(e) {
  if (!e.detail) { return; }

  musicTiming.start();
  googleAnalytics.event('music', 'play', {
    eventLabel: e.detail.src
  });
};

AnalyticsMonitor.prototype.handleMusicPause = function onMusicPause(e) {
  if (!e.detail) { return; }

  musicTiming.extend();
  googleAnalytics.event('music', 'pause', {
    eventLabel: e.detail.src,
    eventValue: Math.floor(e.detail.time)
  });
};

AnalyticsMonitor.prototype.handleMusicComplete = function onMusicEnd(e) {
  if (!e.detail) { return; }

  musicTiming.extend();
  googleAnalytics.event('music', 'ended', {
    eventLabel: e.detail.src,
    eventValue: Math.floor(e.detail.time)
  });
};

AnalyticsMonitor.prototype.handleMusicProgress = function onMusicProgress(e) {
  musicTiming.extend();

  const trackSrc = e.detail && e.detail.src;
  if (trackSrc) {
    const time = e.detail.time;
    const windowedTime = Math.floor(time / TIMING_INCREMENT) * TIMING_INCREMENT;

    if (windowedTime > (listeningTimestamps[trackSrc] || 0)) {
      listeningTimestamps[trackSrc] = windowedTime;

      googleAnalytics.event('music', 'listening', {
        eventLabel: trackSrc,
        eventValue: windowedTime,
        nonInteraction: true
      });
    }
  }

  const windowedTotalMusic = Math.floor(musicTiming.total / TIMING_INCREMENT) * TIMING_INCREMENT;
  if (windowedTotalMusic > lastTotalMusic) {
    lastTotalMusic = windowedTotalMusic;
    googleAnalytics.event('music', 'total', {
      eventLabel: 'Session Total Music Playback',
      eventValue: Math.floor(windowedTotalMusic),
      nonInteraction: true
    });
  }
};

module.exports = AnalyticsMonitor;



//////////////////
// WEBPACK FOOTER
// ./src/js/core/analytics.js
// module id = 42
// module chunks = 0